import { render, staticRenderFns } from "./Corona.vue?vue&type=template&id=1c0b1282&scoped=true&"
import script from "./Corona.vue?vue&type=script&lang=js&"
export * from "./Corona.vue?vue&type=script&lang=js&"
import style0 from "@/assets/corona.css?vue&type=style&index=0&id=1c0b1282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b1282",
  null
  
)

export default component.exports